import { useMemo, useState } from "react";

const flagCodeBySlug = {
  usa: "us",
  canada: "ca",
  uk: "gb",
  australia: "au",
  uae: "ae",
  "new-zealand": "nz",
  europe: "eu",
  ireland: "ie",
  germany: "de"
};

function CountryFlagIcon({ slug, name, width = 20, height = 14, className = "" }) {
  const [hasError, setHasError] = useState(false);
  const flagCode = flagCodeBySlug[slug];
  const fallbackLabel = useMemo(
    () => (flagCode ? flagCode.toUpperCase() : (name || "").slice(0, 2).toUpperCase()),
    [flagCode, name]
  );

  if (!flagCode || hasError) {
    return (
      <span
        aria-hidden="true"
        className={`inline-flex items-center justify-center rounded bg-slate-100 px-1.5 py-0.5 text-[10px] font-bold uppercase tracking-wide text-slate-text ${className}`}
      >
        {fallbackLabel}
      </span>
    );
  }

  return (
    <img
      src={`https://flagcdn.com/w40/${flagCode}.png`}
      srcSet={`https://flagcdn.com/w80/${flagCode}.png 2x`}
      width={width}
      height={height}
      alt={`${name} flag`}
      className={`inline-block rounded-[2px] object-cover shadow-sm ${className}`}
      loading="lazy"
      onError={() => setHasError(true)}
    />
  );
}

export default CountryFlagIcon;
